export default __webpack_public_path__ + "static/media/c.6b2a82c7.mp4";